module.exports = __webpack_public_path__ + "fonts/DINPro-Light.7b131874.woff";